import React, { forwardRef, useState } from 'react';
import ReactSelect, { components } from 'react-select';

// react-select remembers the last pointer-focused option after the pointer leaves.
// Only keyboard navigation should paint that retained focus; pointer uses :hover.
function Option(props) {
  const Component = props.selectProps.originalOption || components.Option;
  return <Component {...props} isFocused={props.isFocused && props.selectProps.keyboardOptionFocus} />;
}
function Menu(props) {
  const Component = props.selectProps.originalMenu || components.Menu;
  return <Component {...props} innerProps={{ ...props.innerProps,
    onPointerMoveCapture: event => {
      props.selectProps.clearKeyboardOptionFocus();
      props.innerProps?.onPointerMoveCapture?.(event);
    },
  }} />;
}
const Select = forwardRef(function Select(props, ref) {
  const [keyboardOptionFocus, setKeyboardOptionFocus] = useState(false);
  return <ReactSelect {...props} ref={ref}
    keyboardOptionFocus={keyboardOptionFocus}
    clearKeyboardOptionFocus={() => setKeyboardOptionFocus(false)}
    originalOption={props.components?.Option}
    originalMenu={props.components?.Menu}
    components={{ ...props.components, Option, Menu }}
    onKeyDown={event => {
      if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'PageDown', 'PageUp'].includes(event.key)) setKeyboardOptionFocus(true);
      props.onKeyDown?.(event);
    }}
    onMenuClose={() => { setKeyboardOptionFocus(false); props.onMenuClose?.(); }}
  />;
});
export default Select;
